import { IEntity } from '@pf/shared-common';
import {
    CarrierFragment,
    ContactBase,
    Currency,
    PackingListFragment,
    ResourceAuth,
    ShipmentAddress,
    ShipmentSearchRequestParams,
    ShipmentStatus,
    ShipmentTypeFragment,
    ShipmentViewModelCreateBody,
    ShipmentViewModelRead,
    WarehouseFragment,
} from '@control-tower/platform-wms';
import { CustomFieldDto } from '@pf/shared/util-platform';
import { IWarehouseEntity } from '../interfaces/warehouse-entity';

export type ShipmentRead = ShipmentViewModelRead & IEntity;
export type ShipmentCreate = ShipmentViewModelCreateBody;
export type ShipmentSearchParams = ShipmentSearchRequestParams;

export class ShipmentDto implements IWarehouseEntity {
    constructor(data: Partial<ShipmentDto>) {
        Object.assign(this, data);
    }
    id!: string;
    warehouse!: WarehouseFragment;
    status!: ShipmentStatus;
    bolNumber?: string | null;
    trailerNumber?: string | null;
    trackingNumber?: string | null;
    resourceAuth?: ResourceAuth;
    externalReferenceId?: string | null;
    expectedDeliveryDate?: string | null;
    actualDeliveryDate?: string | null;
    expectedPickupDate?: string | null;
    actualPickupDate?: string | null;
    shipmentValue?: Currency;
    shipTo?: ShipmentAddress;
    shipToContact?: ContactBase;
    createdDate?: string;
    modifiedDate?: string;
    isDeleted?: boolean;
    customFields?: Array<CustomFieldDto> | null;
    packingLists?: Array<PackingListFragment> | null;
    loads?: Array<string> | null;
    carrier?: CarrierFragment;
    shipmentType?: ShipmentTypeFragment;
}
